import { Component, OnInit, TemplateRef } from '@angular/core';
import { Auth, Storage } from 'aws-amplify';
import { ConstantsService } from "../services/constants.service";
import { DataService } from '../services/data.service';
import { UrlConstants } from '../services/url-constants';
import { environment } from '../../environments/environment'
import { AdminService } from '../services/admin.service';
import { CacheService } from '../services/cache.service';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MyWindowEditComponent } from '../my-window-edit/my-window-edit.component';
import { Router } from '@angular/router';
import { SpinnerService } from '../services/spinner.service';
import { Title } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
const MYWINDOW_CACHE_KEY = "myWindowCache"
import { SessionService } from '../services/session.service';

@Component({
  selector: 'app-myvideos',
  templateUrl: './myvideos.component.html',
  styleUrls: ['./myvideos.component.scss']
})
export class MyvideosComponent implements OnInit {
  public videoStatus: any;
  public currentUser = "";
  public queueArray = [];
  public uploadedArray = [];
  public isEmptyWindow = false;
  public isLoading = false;
  public skeltonArray = [];
  public uploadedVideos = [];
  public currentUserList
  public urlPrefix = environment.S3_URL_PRFIX;
  public id = "";
  public currentVideoStatus;
  public currentVideoName;
  public isRemoving = false;
  public videoId;
  public bookmarkCount
  public bCount = [];
  formattedDate: string;
  videoIdData: any;
  campaignId: any;
  public deleteItem: any;
  public isadmin = false;
  videosToFetch;
  constructor(
    public constants: ConstantsService,
    private dataService: DataService,
    private urlConstants: UrlConstants,
    private adminservice: AdminService,
    private authenticate: CacheService,
    private spinner: SpinnerService,
    private datePipe: DatePipe,
    private title: Title,
    public dialog: MatDialog,
    private sessionService: SessionService,
    private route: Router,) {
    var skelton = [
      constants.MY_WINDOW_SKELTON_IMG,
      constants.MY_WINDOW_SKELTON_IMG,
      constants.MY_WINDOW_SKELTON_IMG,
      constants.MY_WINDOW_SKELTON_IMG,
      constants.MY_WINDOW_SKELTON_IMG,
      constants.MY_WINDOW_SKELTON_IMG,
      constants.MY_WINDOW_SKELTON_IMG,
      constants.MY_WINDOW_SKELTON_IMG,]
    this.skeltonArray = skelton;
  }

  ngOnInit(): void {
    this.load();
  }
  load = async () => {
    this.isLoading = true;
    let authorObj = this.sessionService.getItem('authorObj');
    if (authorObj) {
      let data = {
        email: authorObj.email,
        name: authorObj.name,
        admin: true
      };
      this.sessionService.removeItem('authorObj');
      this.adminservice.shareUserData(data);
    }
    let userDetails = this.adminservice.getSharedUserData()
    if (userDetails !== undefined) {
      this.currentUser = userDetails.email
      if (userDetails.hasOwnProperty("admin")) {
        this.isadmin = true;
      }
      this.title.setTitle(`${this.constants.WINDOW_SWAP_TXT} - My Windows`);
    }
    else {
      await this.authenticate.getAuthUser()
        .then(async data => {
          this.title.setTitle(`${this.constants.WINDOW_SWAP_TXT} - ${data.given_name}'s Windows`);
          let { email, login } = data
          this.currentUser = email
          if (!login) {
            this.route.navigate(['/login'])
          }
          this.spinner.hide()
        })
        .catch(error => {
          this.spinner.hide()
        })
    }
    this.myvideos()
  }
  //   this.myvideos()
  // }

  async myvideos() {
    let params;
    if (this.isadmin) {
      params = [
        { param: '{object}', value: "getUserVideosAdmin" },
        { param: '{id1}', value: this.currentUser },
        { param: '{id2}', value: 'GetUserVideosAdmin' },
      ];
    } else {
      params = [
        { param: '{object}', value: "getUserVideos" },
        { param: '{id1}', value: this.currentUser },
        { param: '{id2}', value: 'GetVideoList' },
      ];
    }
    let videoList;
    await this.dataService.getData(this.urlConstants.getUri(this.urlConstants.getList, params)).subscribe(async data => {
      if (data !== undefined) {
        if (data["Items"].hasOwnProperty("userDetails")) {
          if (data["Items"]["userDetails"]["Items"][0] !== undefined) {
            let user = data["Items"]["userDetails"]["Items"][0];
            let userDetails = this.adminservice.getSharedUserData();
            if (user.member_id !== undefined) {
              userDetails.memberId = user.member_id;
            }
            if (user.profile_picture !== undefined) {
              userDetails.profilePicture = user.profile_picture;
            }
            if (user.first_name !== undefined && user.first_name !== "") {
              userDetails.first_name = user.first_name;
            }
            this.adminservice.shareUserData(userDetails);
          }
        }
        if (data['Items']['liveVideo'] !== undefined) {
          this.uploadedArray = data['Items']['liveVideo'];
          this.uploadedArray.forEach((element) => {
            if (element.createdAt) {
              const date = new Date(element.createdAt);
              this.formattedDate = this.datePipe.transform(date, 'MMM dd yyyy').toUpperCase();
              element['uploadedOn'] = this.formattedDate
            }
          })
        }
        if (data['Items']['pendingVideo'] !== undefined) {
          this.queueArray = data['Items']['pendingVideo'];
          if(this.queueArray.length>0){
            this.fetchThumbnailsAndUpdateVideoStatus()
          }
          // this.queueArray.forEach((ele) =>{
          //   if(ele.dateRecording){
          //     this.formattedDate = new Date(ele.dateRecording * 1000).toLocaleDateString('en-US', {
          //       month: 'short',
          //       day: 'numeric',
          //       year: 'numeric'
          //     });
          //   }s
          // })
        }
        if (this.uploadedArray.length === 0 && this.queueArray.length === 0) {
          this.isEmptyWindow = true;
          this.isLoading = false;
        }
        this.isLoading = false
        if (this.isadmin) {
          this.adminservice.hideUserProfileSkeleton();
        }
      }
      else {
        this.isEmptyWindow = true;
        this.isLoading = false;
      }
    }, err => {
      this.isEmptyWindow = true;
      this.isLoading = false;
    });
  }
  onClickClosePopup() {
    document.getElementById("modal-popup").style.display = "none"
  }
  onClickShowPopup() {
    document.getElementById("modal-popup").style.display = "flex"
  }
  onClickShowConfirmPopup(item, event) {
    this.id = event.target.name;
    this.currentVideoStatus = item.videoStatus;
    this.currentVideoName = item.videoName;
    document.getElementById("modal-popup-confirm").style.display = "flex"
  }
  onClickCloseConfirmPopup() {
    document.getElementById("modal-popup-confirm").style.display = "none"
  }
  openDialog(item) {
    this.deleteItem = item;
    document.getElementById("delete-modal-popup-confirm").style.display = "flex"
    console.log(item, 'item')
    //this.id = item.videoName;
    this.videoIdData = item.videoId;
    this.campaignId = item.campaignId
    //   this.currentVideoName = item.videoName;
  }
  closeDialog() {
    document.getElementById("delete-modal-popup-confirm").style.display = "none"
    this.deleteItem = null;
  }
  async onDelete() {

    this.isRemoving = true
    const params = [{ param: '{object}', value: 'videos' }];
    const bodyObj = {
      campaignId: this.campaignId,
      videoId: this.videoIdData,
    };
    try {
      this.dataService
        .postData(
          this.urlConstants.getUri(this.urlConstants.deleteItem, params), JSON.stringify(bodyObj))
        .subscribe(async (data) => {
          document.getElementById("delete-modal-popup-confirm").style.display = "none"
          document.getElementById("confirm").style.display = "block"
          this.isRemoving = false;
          setTimeout(function () {
            document.getElementById("confirm").style.display = "none"
          }, 7000);
          this.myvideos()
        }, error => {
          this.isRemoving = false;
        })
    } catch (e) {
      // console.log('error------0', e);
    }

  }
  // async onClickRemove() {
  //   document.getElementById(this.id).style.opacity = "50%"
  //   this.isRemoving = true
  //   await Storage.remove(`${this.currentVideoStatus}/${this.currentVideoName}`, {
  //     bucket: `${environment.VIDEO_BUCKET}`,
  //   })
  //     .then((data) => {
  //       const params = [
  //         { param: '{object}', value: "submit" },
  //       ];
  //       const bodyObj = {
  //         "commonKey": this.constants.VIDEO_COMMON_KEY,
  //         "videoName": this.id,
  //       }
  //       this.dataService.postData(this.urlConstants.getUri(this.urlConstants.deleteItem, params), JSON.stringify(bodyObj))
  //         .subscribe((data) => {
  //           document.getElementById(this.id).style.display = "none"
  //           document.getElementById("modal-popup-confirm").style.display = "none"
  //           document.getElementById("confirm").style.display = "block"
  //           this.isRemoving = false;
  //           setTimeout(function () {
  //             document.getElementById("confirm").style.display = "none"
  //           }, 7000);
  //           this.myvideos()
  //         }, err => {
  //           this.isRemoving = false;
  //         })
  //     })
  // }
  onClickVideoTitle(item) {
    let videoUrl = item.url
    let videoid = item.videoId
    let shareUrl = `${window.location.origin}/Window/${videoid}`;
    navigator.clipboard.writeText(shareUrl).then(() => {
      window.open(`/Window/${videoid}`, '_blank');
    })
  }

  openEditDialog(item) {
    let dialogRef = this.dialog.open(MyWindowEditComponent, {
      data: item,
      // maxHeight: '90vh',
    })
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.myvideos();
      }
      this.queueArray.filter((res) => {
        if (result != undefined && res.videoName === result[0].videoName) {
          res.cityLocation = result[0].updatedLocation
          res.nickName = result[0].updatedNickname
          res.tag = result[0].tags
          res.country = result[0].updatedCountry
          res.videoTitle = result[0].updatedTitle
          res.tag.Animals = result[0].tags.Animals
          res.tag.DayVideo = result[0].tags.DayVideo
          res.tag.Interiors = result[0].tags.Interiors
          res.tag.Water = result[0].tags.Water
          res.tag.Nature = result[0].tags.Nature
          res.tag.Night = result[0].tags.Night
          res.tag.Rain = result[0].tags.Rain
          res.tag.Snow = result[0].tags.Snow

        }
      })
    })
  }
  openMobileEditDialog(item) {
    let dialogRef = this.dialog.open(MyWindowEditComponent, {
      data: item,
      panelClass: 'full-width-dialog',
      maxWidth: '100vw',
      maxHeight: '100vh',
      autoFocus: false,
    })
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.myvideos();
      }
      this.queueArray.filter((res) => {
        if (result != undefined && res.videoName === result[0].videoName) {
          res.cityLocation = result[0].updatedLocation
          res.nickName = result[0].updatedNickname,
            res.timeRecording = result[0].updatedDateRecording,
            res.timeRecording = result[0].updatedTimeRecording,
            res.tag = result[0].tags
          res.country = result[0].updatedCountry
          res.videoTitle = result[0].updatedTitle
          res.tag.Animals = result[0].tags.Animals
          res.tag.DayVideo = result[0].tags.DayVideo
          res.tag.Interiors = result[0].tags.Interiors
          res.tag.Water = result[0].tags.Water
          res.tag.Nature = result[0].tags.Nature
          res.tag.Night = result[0].tags.Night
          res.tag.Rain = result[0].tags.Rain
          res.tag.Snow = result[0].tags.Snow
        }
      })
    })
  }

  async onClickRemove() {
    //  document.getElementById(this.id).style.opacity = "50%"
    const id = this.deleteItem.videoName;
    const currentVideoStatus = this.deleteItem.videoStatus;
    const currentVideoName = this.deleteItem.videoName;
    this.isRemoving = true
    const params = [
      { param: '{object}', value: "submit" },
    ];
    const bodyObj = {
      "commonKey": this.constants.VIDEO_COMMON_KEY,
      "videoName": id,
      "vimeoToken": this.deleteItem.vimeoToken,
      "videoUrl": this.deleteItem.videoUrl
    }
    this.dataService.postData(this.urlConstants.getUri(this.urlConstants.deleteItem, params), JSON.stringify(bodyObj)).subscribe({
      next: async (data: any) => {
        await this.myvideos();
        this.isRemoving = false;
        this.closeDialog();
        document.getElementById("confirm").style.display = "block"
        // this.isRemoving = false;
        setTimeout(function () {
          document.getElementById("confirm").style.display = "none"
        }, 7000);
      },
      error: (err) => {
        this.isRemoving = false
      }
    })
  }

  // locationForQueVideos(item, limit){
  //   let location = item.cityLocation + ' - ' + item.country;
  //   if(location.length <= limit){
  //     return location;
  //   }else {
  //     return location.slice(0, limit) + '...';
  //   }
  // }

  // locationForUploadedVidos(item, limit){
  //   let location = item.cityLocation;
  //   if(location.length <= limit){
  //     return location;
  //   }else {
  //     return location.slice(0, limit) + '...';
  //   }
  // }

  fetchCity(item){
    return item.cityLocation.split('-')[0];
  }

  fetchThumbnailsAndUpdateVideoStatus() {
    this.videosToFetch = this.queueArray.filter((video) => {
      return video.thumbnail == this.constants.VIMEO_DEFAULT_THUMBNAIL
    })
    if (this.videosToFetch.length > 0) {
      const params = [
        { param: '{actionName}', value: 'updateThumbs' }
      ]
      const postdata = {
        "videosToFetch": this.videosToFetch
      }
      this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, params), postdata).subscribe((data: any) => {
        if (data.status === 'success' && data.response?.updatedVideos) {
          const updatedVideos = data.response.updatedVideos;
          
          // Process updates and removals
          updatedVideos.forEach((updatedVideo: any) => {
            const videoName = updatedVideo.videoName;
            const videoStatus = updatedVideo.updatedData?.finalStatus;
            const videoIndex = this.queueArray.findIndex((video: any) => video.videoName === videoName);
             if (videoStatus !== 'failed' && videoIndex !== -1){
                this.queueArray[videoIndex] = { ...this.queueArray[videoIndex], ...updatedVideo.updatedData };
            }
            
          });
        }

      }, (error) => {
        console.log("Error in fetching thumbnails", error);
      })
    }
  }
  
}
